import type { PluginCatalogueItem } from '@/shared/api/types/plugins';

export function PluginAutomationSettingsLink({ plugin }: { plugin: PluginCatalogueItem }) {
  return (
    <div className="border-line text-ink-soft space-y-3 border-t pt-5 text-sm">
      <p>
        GuestAI benötigt einen eigenen Login. Antwortzeiten und die Freigabe automatischer Antworten
        verwalten Sie dort mit Ihren zugewiesenen Rechten.
      </p>
      {plugin.communicationSettingsUrl && plugin.installation?.state === 'Active' && (
        <a
          href={plugin.communicationSettingsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sage inline-flex min-h-11 items-center font-medium underline underline-offset-4"
        >
          Antwortzeiten in GuestAI einstellen
        </a>
      )}
    </div>
  );
}
